<template>
  <div>
    <div
      style="
        position: fixed;
        left: 0px;
        top: 20px;
        z-index: 4;
        backdrop-filter: blur(2px);
      "
      v-if="loaderStatus"
    >
      <Spinner />
    </div>
    <template
      v-if="
        jobData.length === 0 && searchQuery !== '' && searchQuery !== 'Loader'
      "
    >
      <div
        class="
          common-innerbody-container
          d-flex
          justify-content-center
          align-items-center
          mt-1
          flex-column
        "
      >
        <div>
          <img src="../../assets/ReportsNew/panel-wrong-search.svg" alt="" />
        </div>
        <div class="no-matching-results-font mt-1 wordbreak text-center">
          No matching results found for <strong>"{{ searchQuery }}"</strong>
        </div>
      </div>
    </template>
    <template
      v-else-if="
        !loaderStatus && jobData.length === 0 && searchQuery === '' && searchQuery !== 'Loader'
      "
    >
      <div
        class="
          common-innerbody-container
          d-flex
          justify-content-center
          align-items-center
          mt-1
          flex-column
        "
      >
        <img src="../../assets/New-job-dashboard/no-data-jobs.svg" alt="" />
        <div class="no-matching-results-font mt-1 wordbreak text-center">
          There are no assigned jobs.
        </div>
      </div>
    </template>
    <template v-else-if="!loaderStatus">
      <div class="mt-4 common-innerbody-container">
        <b-row class="flex-nowrap add-gap">
          <b-col cols="6">
            <b-row class="head">
              <b-col cols="2"> Customer </b-col>
              <b-col cols="3"> Job Name </b-col>
              <b-col cols="7"> Position ID </b-col>
            </b-row>
          </b-col>
          <b-col cols="6">
            <b-row class="head">
              <b-col cols="4"> Status </b-col>

              <b-col cols="3" class="p-0"> No. of Candidates </b-col>
              <b-col cols="5" class="p-0"> Recruiter Name </b-col>
            </b-row>
          </b-col>
        </b-row>
        <section class="common-inner-container-overflow">
          <b-row
            class="flex-nowrap add-gap job-item"
            v-for="(job, ind) in jobData"
            :key="ind"
          >
            <b-col>
              <b-row class="flex-nowrap add-gap">
                <b-col cols="6" class="set-rec-col-padding">
                  <b-row class="body">
                    <b-col cols="2" class="p-0">
                      <b-avatar
                        class="cancelled-class defaultCursor"
                        v-b-tooltip.hover.bottom="job.name"
                        >{{ getUserIcon(job.name) }}
                      </b-avatar>
                    </b-col>

                    <b-col cols="3" class="p-0">
                      <div
                        style="max-width: 85%"
                        class="mt-1 text-truncate defaultCursor"
                        v-b-tooltip.hover.bottom="job.jobName"
                      >
                        {{ job.jobName ? job.jobName : "-" }}
                      </div>
                    </b-col>
                    <b-col cols="7" class="p-0">
                      <template v-if="job.positions.length">
                        <div style="display: flex; flex-wrap: wrap">
                          <b-avatar-group
                            class="common-blueAvatar-main-container"
                          >
                            <b-avatar
                              class="avatar-base-style"
                              v-for="(posID, index) in job.positions.slice(
                                0,
                                5
                              )"
                              :style="{
                                ...getAvatarStyle(posID.status),
                                width: posID.isExpanded ? '90px' : '33px',
                                'box-shadow': posID.isExpanded
                                  ? ' 0px 4px 4px 0px #00000033 !important'
                                  : 'unset',
                                'border-radius': posID.isExpanded
                                  ? '20px !important'
                                  : '',
                              }"
                              @click="getPositionIDDetails(ind, index)"
                              :key="index"
                              button
                              v-b-tooltip.hover.bottom="posID.positionID"
                            >
                              {{
                                posID.isExpanded
                                  ? posID.positionID
                                  : getUserIcon(posID.positionID)
                              }}
                            </b-avatar>
                            <b-avatar
                              v-closeArray="{
                                ind,
                                property: 'openPosIDDropdown',
                                array: jobData,
                                handler: closeJobDropdown(ind),
                                exclude: ['jobDropDown'],
                              }"
                              v-if="job.positions.length > 5"
                              class="extra-lightblue-div pointer"
                              @click="openPosIDDropdown(ind)"
                              button
                            >
                              +{{ job.positions.length - 5 }}
                            </b-avatar>
                          </b-avatar-group>
                          <template
                            v-if="
                              job.positions.length > 5 && job.openPosIDDropdown
                            "
                          >
                            <div class="relativeclass jobDropDown">
                              <div
                                class="
                                  newInt-radio-dropdown
                                  p-0
                                  rec-view-dropdown
                                "
                              >
                                <b-form-group
                                  class="
                                    sec-mcq-datacard sec-mcq-datacard-height
                                  "
                                >
                                  <b-form-radio-group
                                    v-model="selectedPositionID"
                                    class="
                                      newInt-radio-dropdown-inner-content
                                      rec-view-dropdown-inner-content
                                      w-100
                                    "
                                    size="sm"
                                    :options="posIDData"
                                    @change="selectPosID(ind)"
                                    buttons
                                    stacked
                                  ></b-form-radio-group>
                                </b-form-group>
                              </div>
                            </div>
                          </template>
                        </div>
                      </template>
                      <template v-else>
                        <div class="not-selected-font mt-1">
                          No Position ID is assigned
                        </div>
                      </template>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col cols="6" class="padding-inline-class">
                  <b-row class="body d-flex align-items-center">
                    <template v-if="!job.isOpen">
                      <b-col cols="12" class="d-flex align-items-center">
                        <div class="not-selected-font">
                          Select the Job Position ID to see the details
                        </div>
                      </b-col>
                    </template>
                    <template v-else>
                      <b-col cols="4">
                        <div class="relativeclass" style="width: 110px">
                          <div
                            @focusout="closeStatusDropdown"
                            tabIndex="0"
                            class="
                              d-flex
                              align-items-center
                              justify-content-between
                              jobSelection-dropdown-div
                              px-3
                            "
                            :style="getAvatarStyle(positionIDData.status)"
                            :class="job.onHold ? 'disable-inputField' : ''"
                            @click="job.onHold ? '' : (dropdown = !dropdown)"
                          >
                            <div class="mr-2">
                              {{ getStatusName(positionIDData.status) }}
                            </div>

                            <img
                              v-show="!dropdown"
                              :src="sourceDownArrow"
                              alt=""
                            />
                            <img
                              v-show="dropdown"
                              :src="sourceUpArrow"
                              alt=""
                            />
                          </div>
                          <div v-if="dropdown" class="relativeclass">
                            <div class="newInt-radio-dropdown p-0">
                              <b-form-group class="sec-mcq-datacard">
                                <b-form-radio-group
                                  class="
                                    newInt-radio-dropdown-inner-content
                                    w-100
                                  "
                                  size="sm"
                                  v-model="selectedStatus"
                                  :options="statusOptions"
                                  @change="
                                    (dropdown = false), (isCommentsModal = true)
                                  "
                                  :disabled="job.onHold"
                                  buttons
                                  stacked
                                >
                                </b-form-radio-group>
                              </b-form-group>
                            </div>
                          </div>
                        </div>
                      </b-col>

                      <b-col cols="3">
                        {{ positionIDData.candidateCount }}
                      </b-col>
                      <b-col cols="5" class="px-4">
                        <div
                          class="text-truncate"
                          style="min-width: auto; max-width: 100%"
                        >
                          <span
                            v-if="recruiterArray.length"
                            v-b-tooltip.hover.bottom="recruiterArray.join(', ')"
                          >
                            {{ recruiterArray.join(", ") }}
                          </span>
                          <span v-else class="not-selected-font mt-1">
                            No Recruiters assigned
                          </span>
                        </div>
                      </b-col>
                    </template>
                  </b-row>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <hr />
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </section>
        <div
          class="
            d-flex
            justify-content-between
            align-items-center
            acs-paginaTion-new
            mx-1
          "
        >
          <div class="d-flex">
            <span class="acs-gotopage-text p-1">Go to page</span>
            <b-form-input
              type="text"
              class="acs-pagination-num mr-1"
              v-model="goToPage"
              @keyup.enter="
                goToPage === null || goToPage == '' || !iscontainsNumber
                  ? ''
                  : goToPages(goToPage)
              "
              @keypress="NumbersOnly"
            ></b-form-input>
            <b-button
              class="acs-pagination-addbtn"
              @click="goToPages(goToPage)"
              :disabled="
                goToPage === null || goToPage == '' || !iscontainsNumber
              "
            >
              <span
                ><img src="../../assets/img/accessconnew/blueRight.svg" alt=""
              /></span>
            </b-button>
          </div>
          <div class="pagination">
            <b-pagination
              v-model.number="currentPage"
              @input="getJobsData(), (goToPage = null)"
              :total-rows="total"
              :per-page="pageCount"
              align="center"
              first-number
              last-number
            >
              <template #prev-text
                ><span
                  ><img
                    src="../../assets/img/accessconnew/pageleft.svg"
                    alt=""
                  /> </span
              ></template>
              <template #next-text
                ><span
                  ><img
                    src="../../assets/img/accessconnew/pageright.svg"
                    alt="" /></span
              ></template>
            </b-pagination>
          </div>
          <div class="d-flex align-items-center">
            <div class="acs-gotopage-text d-flex justify-content-end">
              Items per page: 10
            </div>
            <div class="acs-gotopage-text mr-2 ml-4 d-flex justify-content-end">
              Showing : <span v-if="pageStart > total">0</span
              ><span v-else>{{ pageStart }}</span> - {{ pageEnd }}
              <span class="pl-1"></span> of <span class="pr-1"></span
              >{{ total }}
            </div>
          </div>
        </div>
      </div>
    </template>
    <CommentsModal
      v-if="isCommentsModal"
      :isCommentsModal="isCommentsModal"
      :buttonLoader="buttonLoader"
      @save-comment="onSaveComment"
      @close-modal="
        (isCommentsModal = false), (selectedStatus = positionIDData.status)
      "
    />
  </div>
</template>

<script>
import {
  getRecruiterData,
  changePositionIDStatus,
} from "../../utils/apiFunctions";
import {
  getAvatarStyle,
  getStatusName,
  getSourceDownArrow,
  getSourceUpArrow,
} from "@/controllers/commonHelpers";
import { NumbersOnly } from "../../controllers/Candidate/helpers";
import { mapGetters } from "vuex";
import CommentsModal from "../jobs/modals/CommentsModal.vue";
import Spinner from "@/components/fixedcomponents/Spinner.vue";

export default {
  name: "JobView",
  data() {
    return {
      dropdown: false,
      isCommentsModal: false,
      loaderStatus: false,
      buttonLoader: false,
      selectedStatus: null,
      selectedIndex: null,
      goToPage: null,
      total: 0,
      currentPage: 1,
      pageCount: 10,
      statusOptions: [
        { text: "Lost", value: 4 },
        { text: "Closed", value: 3 },
        { text: "On-Hold", value: 2 },
        { text: "Active", value: 1 },
        { text: "Cancelled", value: 0 },
      ],
      jobData: [],
      recruiterArray: [],
      positionIDData: {},
      sourceDownArrow: "",
      sourceUpArrow: "",
      pageStart: "",
      pageEnd: "",
      selectedPositionID: {},
      posIDData: [],
    };
  },
  components: {
    CommentsModal,
    Spinner,
  },
  created() {
    this.$store.commit("searchVUEX/saveSearchQuery", "");
    this.getJobsData();
  },
  computed: {
    iscontainsNumber() {
      return /^[1-9]\d*$/.test(this.goToPage);
    },
    totalPages() {
      return Math.ceil(this.total / this.pageCount);
    },
    ...mapGetters("searchVUEX", {
      searchQuery: "getSearchQuery",
    }),
  },
  watch: {
    searchQuery(newValue, oldValue) {
      if (newValue != oldValue) {
        if (newValue != "Loader") {
          this.currentPage = 1;
          this.getJobsData();
        }
      }
    },
  },
  methods: {
    updatePage(value) {
      this.pageCount = value;
      this.currentPage = 1;
      this.getJobsData();
    },
    goToPages(index) {
      this.currentPage = Math.min(Math.max(1, index), this.totalPages);
      this.goToPage = null;
      this.getJobsData();
    },
    NumbersOnly(evt) {
      NumbersOnly(evt);
    },
    closeJobDropdown(index) {
      return () => {
        this.jobData[index].openPosIDDropdown = false;
        this.$forceUpdate();
      };
    },
    closeStatusDropdown() {
      setTimeout(() => {
        this.dropdown = false;
      }, 500);
    },
    async getJobsData() {
      try {
        this.loaderStatus = true;
        let payload = {
          type: 2,
          count: this.pageCount,
          page: this.currentPage - 1,
          searchQuery: this.searchQuery,
        };
        let res = await getRecruiterData(payload);
        if (res.status === 200) {
          this.jobData = res.data.data.data;
          this.pageStart = res.data.data.pageStart;
          this.pageEnd = res.data.data.pageEnd;
          this.total = res.data.data.total;
          this.jobData.forEach((job) => {
            job.positions.forEach((pos) => {
              pos.isExpanded = false;
            });
            job.isOpen = false;
            job.openPosIDDropdown = false;
          });
          this.loaderStatus = false;
        }
      } catch (error) {
        console.error(error);
      }
    },
    getUserIcon(jobName) {
      if (!jobName || jobName.trim() === "") {
        return "-";
      }
      let parts = jobName
        .trim()
        .split(" ")
        .filter((part) => part !== "");
      if (parts.length > 0 && parts[0]) {
        if (parts.length > 1) {
          if (/[^a-zA-Z]/.test(parts[1])) {
            return parts[0][0].toUpperCase();
          } else {
            return parts[0][0].toUpperCase() + parts[1][0].toUpperCase();
          }
        } else {
          return parts[0][0].toUpperCase();
        }
      }
      return "-";
    },
    getAvatarStyle(status) {
      return getAvatarStyle(status);
    },
    getPositionIDDetails(ind, index) {
      this.selectedPositionID = "";
      this.jobData.forEach((job, jobIndex) => {
        if (jobIndex === ind) {
          job.positions.forEach((pos, posIndex) => {
            if (posIndex !== index) {
              pos.isExpanded = false;
            }
          });
        } else {
          job.positions.forEach((pos) => {
            pos.isExpanded = false;
          });
        }
        job.isOpen = false;
        job.openPosIDDropdown = false;
      });

      const selectedPosition = this.jobData[ind].positions[index];
      selectedPosition.isExpanded = !selectedPosition.isExpanded;

      if (selectedPosition.isExpanded) {
        this.jobData[ind].isOpen = true;
        this.positionIDData = selectedPosition;
        this.recruiterArray = selectedPosition.activeAssigned.map(
          (rec) => rec.username
        );
      } else {
        this.positionIDData = {};
      }

      this.selectedIndex = ind;
      this.selectedStatus = selectedPosition.status;
      this.sourceDownArrow = this.getSourceDownArrow(this.selectedStatus);
      this.sourceUpArrow = this.getSourceUpArrow(this.selectedStatus);

      this.$forceUpdate();
    },
    openPosIDDropdown(ind) {
      this.posIDData = [];
      this.jobData.forEach((job) => {
        job.openPosIDDropdown = false;
      });
      this.jobData[ind].openPosIDDropdown = true;
      this.jobData[ind].positions.slice(5).forEach((pos) => {
        this.posIDData.push({
          text: pos.positionID,
          value: pos,
        });
      });
      this.$forceUpdate();
    },
    selectPosID(ind) {
      this.jobData.forEach((job) => {
        job.positions.forEach((pos) => {
          pos.isExpanded = false;
        });
        job.isOpen = false;
        job.openPosIDDropdown = false;
      });
      this.positionIDData = this.selectedPositionID;
      this.recruiterArray = this.positionIDData.activeAssigned.map(
        (rec) => rec.username
      );
      this.selectedIndex = ind;
      this.jobData[ind].isOpen = true;
      this.selectedStatus = this.positionIDData.status;
      this.sourceDownArrow = this.getSourceDownArrow(this.selectedStatus);
      this.sourceUpArrow = this.getSourceUpArrow(this.selectedStatus);
      this.$forceUpdate();
    },
    getSourceDownArrow(status) {
      return getSourceDownArrow(status);
    },
    getSourceUpArrow(status) {
      return getSourceUpArrow(status);
    },
    getStatusName(status) {
      return getStatusName(status);
    },
    async onSaveComment(comment) {
      try {
        this.buttonLoader = true;
        let payload = {
          jobID: this.positionIDData.jobID,
          positionID: this.positionIDData.positionID,
          status: this.selectedStatus,
          comments: comment,
        };
        let res = await changePositionIDStatus(payload);
        if (res.status === 200) {
          await this.getJobsData();
          this.$nextTick(() => {
            const jobElement =
              this.$el.querySelectorAll(".job-item")[this.selectedIndex];
            if (jobElement) {
              jobElement.scrollIntoView({
                behavior: "smooth",
                block: "center",
              });
            }
          });
          let index = this.jobData[this.selectedIndex].positions.findIndex(
            (pos) => pos.positionID === this.positionIDData.positionID
          );
          if (index <= 4) {
            this.getPositionIDDetails(this.selectedIndex, index);
          } else {
            this.selectedPositionID =
              this.jobData[this.selectedIndex].positions[index];
            this.selectPosID(this.selectedIndex);
          }
          this.isCommentsModal = false;
          this.buttonLoader = false;
        }
      } catch (error) {
        console.error(error);
      }
    },
    hidePosIDDropdown() {
      this.dropdown = false;
      this.$forceUpdate();
    },
  },
};
</script>

<style scoped>
.avatar-base-style {
  height: 33px !important;
  transition: width 0.3s, height 0.3s !important;
  margin-right: -10px !important;
  box-shadow: unset !important;
  font-family: "Lato", sans-serif;
  font-size: var(--size-12);
  display: flex;
  align-items: center;
  border: var(--bg-white) solid 1px !important;
}

.padding-inline-class {
  padding-left: 19px;
  padding-right: 44px;
}

.acs-paginaTion-new {
  min-width: 1002px;
  max-width: 100%;
}
</style>
